
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock, User, Users } from "lucide-react";
import { ClassDetails } from "@/types/attendance";

interface ClassDetailsCardProps {
  classDetails: ClassDetails;
}

export const ClassDetailsCard = ({ classDetails }: ClassDetailsCardProps) => {
  // Formatear horario
  const formatSchedule = (schedule?: string) => {
    if (!schedule) return "";
    
    if (/^\d{2}:\d{2}$/.test(schedule)) {
      return schedule;
    }

    const hour = parseInt(schedule);
    if (!isNaN(hour)) {
      return `${hour.toString().padStart(2, '0')}:00`;
    }

    return schedule;
  };

  return (
    <Card className="mb-6 bg-[#293233] dark:bg-[#2196A3]/10 forest:bg-black/10 ocean:bg-black/10 sunset:bg-black/10 border border-[#00C1D6]/20 text-white sunset:bg-black/20 sunset:border-black">
      <CardHeader>
        <CardTitle>{classDetails.title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex items-center text-white/70">
          <User className="h-4 w-4 mr-2" />
          <span>Instructor: {classDetails.instructor}</span>
        </div>
        <div className="flex items-center text-white/70">
          <Clock className="h-4 w-4 mr-2" />
          <span>Horario: {formatSchedule(classDetails.schedule)} ({classDetails.duration} min)</span>
        </div>
        <div className="flex items-center text-white/70">
          <Users className="h-4 w-4 mr-2" />
          <span>Capacidad: {classDetails.capacity} alumnos</span>
        </div>
      </CardContent>
    </Card>
  );
};
